<template>
  <div class="combo-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card>
            <div slot="header">
              {{$t('client.basic_information')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in combo.basic_info" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="combo.basic_info[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.disable')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="combo.basic_info[i].disable" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.single')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in combo.single" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="combo.single[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.disable')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="combo.single[i].disable" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.first_layer')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in combo.first" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="combo.first[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.disable')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="combo.first[i].disable" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.second_layer')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-for="(option, i) in combo.second" :key="i+0" v-bind:label="option.name" :label-cols="4" :horizontal="true">
                  <b-row>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.display')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="combo.second[i].show" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                    <b-col cols="6">
                      <b-form-group v-bind:label="$t('client.disable')" label-cols="3" :horizontal="true">
                        <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                  :pill="true" v-model="combo.second[i].disable" :value="true" :uncheckedValue="false"/>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.config')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <b-form-group v-bind:label="$t('client.combo_price')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.combo_price" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.combo_multi_price')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.combo_multi_price" :value="true" :uncheckedValue="false"/>
                </b-form-group>

                <b-form-group v-bind:label="$t('client.single_price')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.single_price" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.single_multi_price')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.single_multi_price" :value="true" :uncheckedValue="false"/>
                </b-form-group>

                <b-form-group v-bind:label="$t('client.first_price')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.first_price" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.first_multi_price')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.first_multi_price" :value="true" :uncheckedValue="false"/>
                </b-form-group>

                <b-form-group v-bind:label="$t('client.second_price')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.second_price" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.second_multi_price')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.second_multi_price" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.multi_category')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.multi_category" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.multi_sub_category')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.multi_sub_category" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.multi_type')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.multi_type" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.more_group')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.more_group" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.more_item')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.more_item" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.more_first')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.more_first" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.more_second')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.more_second" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.special_date')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.special_date" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.opening_hours')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.opening_hours" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.product_tax_price')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.product_tax_price" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.product_point')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.product_point" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.publish_etl')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.publish_etl" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.combo_attribute')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.combo_attributes" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.set_default')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.set_default" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.export_price')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.export_price" :value="true" :uncheckedValue="false"/>
                </b-form-group>
                <b-form-group v-bind:label="$t('client.seo_configuration')" label-cols="3" :horizontal="true">
                  <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="combo.config.seo_configuration" :value="true" :uncheckedValue="false"/>
                </b-form-group>
              </b-col>
            </b-form>
          </b-card>
          <b-card>
            <div slot="header">
              {{$t('client.customization')}}
            </div>
            <b-form class="row">
              <b-col cols="12">
                <customization v-model="combo.fields" :position_fields="position_fields"></customization>
              </b-col>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import cSwitch from '../../../components/Switch'
  import Customization from './Customization'

  export default {
    name: 'ComboForm',
    props: {
      value: {
        type: Object
      }
    },
    components: {
      Customization,
      cSwitch
    },
    data: function () {
      return {
        position_fields: [
          'name_seo',
          'code',
          'display_date',
          'properties'
        ],
        combo: {
          basic_info: [
            {
              'name': 'Link to FCDS',
              'type': 'link_to_fcds',
              'show': true,
              'disable': false
            },
            {
              'name': 'ID',
              'type': 'id',
              'show': true,
              'disable': false
            },
            {
              'name': 'Short Name',
              'type': 'name_seo',
              'show': true,
              'disable': false
            },
            {
              'name': 'Friendly Seo Name',
              'type': 'friendly_seo_name',
              'show': false,
              'disable': false
            },
            {
              'name': 'Sku',
              'type': 'sku',
              'show': true,
              'disable': false
            },
            {
              'name': 'Aggregator Code',
              'type': 'aggregator_code',
              'show': true,
              'disable': false
            },
            {
              'name': 'Name',
              'type': 'name',
              'show': true,
              'disable': false
            },
            {
              'name': 'Sequence',
              'type': 'sequence',
              'show': true,
              'disable': false
            },
            {
              'name': 'Description',
              'type': 'marketing_description',
              'show': true,
              'disable': false
            },
            {
              'name': 'Details',
              'type': 'main_description',
              'show': true,
              'disable': false
            },
            {
              'name': 'T&C',
              'type': 't_and_c',
              'show': true,
              'disable': false
            },
            {
              'name': 'Category',
              'type': 'category',
              'show': true,
              'disable': false
            },
            {
              'name': 'Display Category',
              'type': 'display_category',
              'show': true,
              'disable': false
            },
            {
              'name': 'Sub-category',
              'type': 'sub_category',
              'show': true,
              'disable': false
            },
            {
              'name': 'Group',
              'type': 'type',
              'show': true,
              'disable': false
            },
            {
              'name': 'Sale Channels',
              'type': 'sale_channels',
              'show': false,
              'disable': false
            },
            {
              'name': 'Display Period',
              'type': 'display_date',
              'show': true,
              'disable': false
            },
            {
              'name': 'Sell Period',
              'type': 'selling_date',
              'show': true,
              'disable': false
            },
            {
              'name': 'Accept Ordering',
              'type': 'duration_date',
              'show': true,
              'disable': false
            },
            {
              'name': 'Image',
              'type': 'image',
              'show': true,
              'disable': false
            },
            {
              'name': 'Half Half',
              'type': 'half_half',
              'show': true,
              'disable': false
            },
            {
              'name': 'Alcohol',
              'type': 'is_alcohol',
              'show': true,
              'disable': false
            },
            {
              'name': 'Only Lunch',
              'type': 'only_lunch',
              'show': true,
              'disable': false
            },
            {
              'name': 'Hut\'s Day',
              'type': 'day_of_hut',
              'show': true,
              'disable': false
            },
            {
              'name': 'Delivery',
              'type': 'delivery',
              'show': true,
              'disable': false
            },
            {
              'name': 'Collection',
              'type': 'collection',
              'show': true,
              'disable': false
            },
            {
              'name': 'Eat-In',
              'type': 'eat_in',
              'show': true,
              'disable': false
            },
            {
              'name': 'Discount',
              'type': 'discount',
              'show': true,
              'disable': false
            },
            {
              'name': 'Is Donation',
              'type': 'is_donation',
              'show': true,
              'disable': false
            },
            {
              'name': 'Display Price',
              'type': 'display_price',
              'show': true,
              'disable': false
            },
            {
              'name': 'Price',
              'type': 'price',
              'show': true,
              'disable': false
            },
            {
              'name': 'Pull Combo From POS',
              'type': 'pull_combo_from_pos',
              'show': false,
              'disable': false
            },
            {
              'name': 'Import Menu',
              'type': 'import_combo',
              'show': false,
              'disable': false
            },
            {
              'name': 'Import Combo Price',
              'type': 'import_combo_price',
              'show': false,
              'disable': false
            },
            {
              'name': 'Allow Type',
              'type': 'allow_type',
              'show': false,
              'disable': false
            }
          ],
          single: [
            {
              'name': 'Price',
              'type': 'price',
              'show': true,
              'disable': false
            }
          ],
          first: [
            {
              'name': 'Name',
              'type': 'name',
              'show': true,
              'disable': false
            },
            {
              'name': 'Sku',
              'type': 'sku',
              'show': true,
              'disable': false
            },
            {
              'name': 'Price',
              'type': 'price',
              'show': true,
              'disable': false
            }
          ],
          second: [
            {
              'name': 'Name',
              'type': 'name',
              'show': true,
              'disable': false
            },
            {
              'name': 'Sku',
              'type': 'sku',
              'show': true,
              'disable': false
            },
            {
              'name': 'Price',
              'type': 'price',
              'show': true,
              'disable': false
            }
          ],
          config: {
            combo_price: true,
            combo_multi_price: false,
            single_price: true,
            single_multi_price: false,
            first_price: true,
            first_multi_price: false,
            second_price: true,
            second_multi_price: false,
            multi_category: false,
            multi_sub_category: false,
            multi_type: false,
            more_group: true,
            more_item: true,
            more_first: true,
            more_second: true,
            opening_hours: false,
            special_date: false,
            product_tax_price: false,
            product_point: false,
            publish_etl: false,
            combo_attributes: false,
            set_default: false,
            export_price: false,
            seo_configuration: false
          },
          fields: [
            {
              "title": "sale_period",
              "body": [
                {
                  "input_type": "masked-input",
                  "name": "sale_from",
                  "options": {
                    "default": "31-12-2008",
                    "class": "form-control col-sm-3 float-left border-radius-4px",
                    "type": "text",
                    "readonly": true
                  }
                },
                {
                  "input_type": "masked-input",
                  "name": "sale_to",
                  "options": {
                    "default": "31-12-9999",
                    "class": "form-control col-sm-3 float-left border-radius-4px",
                    "type": "text",
                    "readonly": true
                  }
                }
              ],
              "position": {
                "after": false,
                "before": true,
                "field": "display_date"
              }
            }
          ]
        }
      }
    },
    methods: {
      updateData () {
        // Update Base Info
        if (this.value != null && this.value.basic_info != null) {
          let basicInfo = {}
          for (let i in this.value.basic_info) {
            basicInfo[this.value.basic_info[i].type] = {
              show: this.value.basic_info[i].show,
              disable: this.value.basic_info[i].disable
            }
          }

          for (let i in this.combo.basic_info) {
            if (basicInfo[this.combo.basic_info[i].type] != null) {
              this.combo.basic_info[i].show = basicInfo[this.combo.basic_info[i].type].show
              this.combo.basic_info[i].disable = basicInfo[this.combo.basic_info[i].type].disable
            }
          }
        }

        // Update First Info
        if (this.value != null && this.value.first != null) {
          let basicInfo = {}
          for (let i in this.value.first) {
            basicInfo[this.value.first[i].type] = {
              show: this.value.first[i].show,
              disable: this.value.first[i].disable
            }
          }

          for (let i in this.combo.first) {
            if (basicInfo[this.combo.first[i].type] != null) {
              this.combo.first[i].show = basicInfo[this.combo.first[i].type].show
              this.combo.first[i].disable = basicInfo[this.combo.first[i].type].disable
            }
          }
        }

        // Update Second Info
        if (this.value != null && this.value.second != null) {
          let basicInfo = {}
          for (let i in this.value.second) {
            basicInfo[this.value.second[i].type] = {
              show: this.value.second[i].show,
              disable: this.value.second[i].disable
            }
          }

          for (let i in this.combo.second) {
            if (basicInfo[this.combo.second[i].type] != null){
              this.combo.second[i].show = basicInfo[this.combo.second[i].type].show
              this.combo.second[i].disable = basicInfo[this.combo.second[i].type].disable
            }
          }
        }

        // Update Config
        if (this.value != null && this.value.config != null) {
          for (let i in this.combo.config) {
            if (this.value.config[i] != null) {
              this.combo.config[i] = this.value.config[i]
            }
          }
        }

        // Update customization field
        if (this.value != null && this.value.fields != null) {
          this.combo.fields = this.value.fields
        }
      }
    },
    created: function () {
    },
    mounted: function () {
      this.updateData()
    },
    watch: {
      combo: {
        handler: function (newValue) {
          this.$emit('input', this.combo)
          this.$emit('change', this.combo)
        },
        deep: true
      },
      value: {
        handler: function (newValue) {
          this.updateData()
        },
        deep: true
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/admin/client/ComboForm.vue